// extracted by mini-css-extract-plugin
export default {"scrollWrap":"ojl53lOx6NCYgQqtWmHF","masklayer":"eb9a0d6eWbnSe6p7J_7h","show-mask":"VQrCZF0sjMOj_sm49oA7","common_bganimation":"MSzhVx1EFGp8iynTXUU1"};